import {DEV_ENV, PROD_ENV} from 'constants/env';

const INTERNAL_ERROR = 'Internal server error';

export const getErrorMessage = (error : Error) => {
  if (!error) return null;
  if (DEV_ENV) {
    if (error.message === INTERNAL_ERROR) return 'UNKNOWN_ERROR';
    return error.message;
  }
  return 'UNKNOWN_ERROR';
}

export const logError = (errorTitle: string, error: any) => {
  if (!PROD_ENV) console.error(errorTitle, error);
}